export const BANK_ACCOUNT_ENDPOINTS = {
  LIST: '/api/bank-accounts',
  CREATE: '/api/bank-accounts',
  UPDATE: '/api/bank-accounts',
  UPLOAD_STATEMENT: '/api/bank-accounts/upload',
  // GET-by-id is the canonical primary-key path for fetching an
  // investor's own account (the LOOKUP-by-iban path needs an unmasked
  // IBAN the list doesn't return).
  DETAIL: '/api/bank-accounts/{id}',
  LOOKUP: '/api/bank-accounts/lookup',
  SET_PRIMARY: '/api/bank-accounts/{id}',
} as const
